export const BATTLEFIELD_SLOT_ZONES = new Set([
  'opponent_front',
  'opponent_flank',
  'your_front',
  'your_flank',
]);

/**
 * Whether a strategem / deploy hit on a battlefield unit should use the lethal white-fade sequence.
 */
export function isBattlefieldUnitLethalHit({
  zoneName,
  index,
  targetInstanceId,
  destroysUnits = false,
  damageAmount = null,
  unitSnapshot = null,
  slotHasUnit = null,
}) {
  if (zoneName == null || index == null || !BATTLEFIELD_SLOT_ZONES.has(zoneName)) {
    return false;
  }
  if (destroysUnits) {
    return true;
  }
  if (typeof unitSnapshot?.health === 'number' && typeof damageAmount === 'number' && damageAmount >= unitSnapshot.health) {
    return true;
  }
  if (
    targetInstanceId &&
    typeof slotHasUnit === 'function' &&
    !slotHasUnit(zoneName, index, targetInstanceId)
  ) {
    return true;
  }
  return false;
}

export function getSlotDamageAnchorFromDom(zoneName, index) {
  if (zoneName == null || index == null) {
    return null;
  }
  const el = document.querySelector(`[data-slot-zone="${zoneName}"][data-slot-index="${index}"]`);
  if (!el) {
    return null;
  }
  const rect = el.getBoundingClientRect();
  return {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
    slotElement: el,
    rect,
  };
}

/** Resolve a deployed unit on a viewer-relative battlefield slot. */
/** Post-damage HP for lethal-death ghost cards (never show pre-hit HP on a dying unit). */
export function postDamageHealthFromSnapshot(unitSnapshot, damageAmount) {
  if (!unitSnapshot || typeof unitSnapshot.health !== 'number') {
    return 0;
  }
  if (typeof damageAmount === 'number' && damageAmount > 0) {
    return Math.max(0, unitSnapshot.health - damageAmount);
  }
  return 0;
}

export function getBattlefieldUnitAtZoneIndex(gameState, viewerUserId, opponentId, zoneName, index) {
  if (!gameState?.state || zoneName == null || index == null || !BATTLEFIELD_SLOT_ZONES.has(zoneName)) {
    return null;
  }
  const zone = zoneName.includes('_front') ? 'front' : zoneName.includes('_flank') ? 'flank' : null;
  if (!zone) return null;
  const playerId = zoneName.startsWith('your_') ? viewerUserId : opponentId;
  if (!playerId) return null;
  const unit = gameState.state[playerId]?.playedOrders?.[zone]?.[index];
  return unit && unit.instanceId ? unit : null;
}
